export default {
    USER_SETTINGS_READ: 'user.settings:read',
    USER_EMAIL_SIGNATURE_WRITE: 'user.email_signature:write',
    USER_EMAIL_SIGNATURE_READ: 'user.email_signature:read',
    USER_QUICK_NOTE_WRITE: 'user.quick_note:write',
};
